import { Component, OnInit } from "@angular/core";
import { AnchorMetadata } from "@common/ADAPT.Common.Model/organisation/anchor";
import { IAdaptLinkObject } from "@common/route/route.service";
import { SearchService } from "@org-common/lib/search/search.service";
import { SearchRowBaseComponent } from "@org-common/lib/search/search-row-base.component";
import { Observable } from "rxjs";
import { StrategicAnchorsPageRoute } from "../../strategic-anchors/strategic-anchors-page/strategic-anchors-page.component";
import { IStrategicAnchorSearchResult } from "../search-results.interface";

@Component({
    selector: "adapt-search-row-strategic-anchor",
    templateUrl: "./search-row-strategic-anchor.component.html",
    standalone: false,
})
export class SearchRowStrategicAnchorComponent extends SearchRowBaseComponent<IStrategicAnchorSearchResult> implements OnInit {
    public readonly AnchorMetadata = AnchorMetadata;

    public href$?: Observable<IAdaptLinkObject>;

    public constructor(
        protected searchService: SearchService,
    ) {
        super(searchService);
    }

    public ngOnInit() {
        super.ngOnInit();

        this.href$ = StrategicAnchorsPageRoute.getRouteObject();
        this.matches = this.excludeNameBreadcrumb(this.result.results);
    }
}
